import { useHttpService } from "@nebulajs/http";
import { reactive } from "vue";

export class AccessService {
  state = reactive({
    initial: false,
    token: null,
    name: "",
    uid: "",
    oid: "",
    root: false,
    access: [],
    control: [],
    organization: [],
    keyword: [],
  });

  get token() {
    const key = `ADMIN_TOKEN`;
    const value = localStorage.getItem(key) ?? null;
    this.state.token = value ?? null;
    return this.state.token;
  }
  set token(value) {
    const key = `ADMIN_TOKEN`;
    localStorage.setItem(key, value ?? "");
    this.state.token = value;
    if (value) return;
    this.state.initial = false;
    this.state.name = "";
    this.state.uid = "";
    this.state.oid = "";
    this.state.root = false;
    this.state.control = [];
    this.state.organization = [];
  }

  get name() {
    return this.state.name;
  }

  get root() {
    return this.state.root;
  }

  get uid() {
    return this.state.uid;
  }

  set uid(value) {
    this.state.uid = value;
  }

  get oid() {
    return this.state.oid;
  }

  set oid(value) {
    this.updateOrganizationAccess(value);
  }

  get control() {
    return this.state.control;
  }

  get organization() {
    return this.state.organization;
  }

  async updateSystemAccess(force) {
    if (!this.token) return true;
    if (!force && this.state.initial) return true;
    const http = useHttpService();
    const { result, data } = await http.post({
      url: "/api/mine/info",
      async: false,
    });
    if (!result) return false;
    this.state.initial = true;
    this.state.name = data.account.name;
    this.state.uid = data.account.account;
    this.state.oid = data.account.organization;
    this.state.root = data.account.root;
    this.state.control = data.access;
    this.state.organization = data.organization;
    return true;
  }

  async updateOrganizationAccess(organization) {
    if (!this.token) return true;
    if (!organization) {
      return this.updateSystemAccess(true);
    }
    const http = useHttpService();
    const { result, data } = await http.post({
      url: "/api/mine/switch",
      data: { organization },
      async: false,
    });
    if (!result) return false;
    this.token = data.token;
    this.state.name = data.info.account.name;
    this.state.uid = data.info.account.account;
    this.state.oid = data.info.account.organization;
    this.state.root = data.info.account.root;
    this.state.control = data.info.access;
    this.state.organization = data.info.organization;
    return true;
  }

  findControlAccess(predicate) {
    const find = (source) => {
      for (const control of source) {
        if (predicate(control)) return control;
        const match = find(control.children);
        if (match) return match;
      }
      return null;
    };
    return find(this.state.control);
  }

  isAccess(key) {
    if (this.state.root) return true;
    const keys = Array.isArray(key) ? key : [key];
    return !!this.findControlAccess((access) => keys.includes(access.key));
  }

  setValue(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getValue(key) {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  getKeywordValue(key) {
    const value = this.getValue(key);
    this.state.keyword = value ?? [];
    return this.state.keyword;
  }

  setKeywordValue(key, value) {
    const text = value.trim();
    if (!text) return;
    const keyword = this.getKeywordValue(key);
    if (keyword.includes(text)) return;
    keyword.unshift(text);
    this.setValue(key, keyword);
    this.state.keyword = keyword;
  }

  install(app) {
    Object.defineProperty(app.config.globalProperties, "$access", {
      enumerable: true,
      get: () => this,
    });
  }
}

export default new AccessService();
